module.exports = __webpack_public_path__ + "img/goodsNo.bed6d9ef.png";